angular.module('picmonicpublic')
    .controller('AppController', ['$rootScope', '$state', function($rootScope, $state){
        $rootScope.$on('$viewContentLoaded', function(event, toState) {
            var stateName = $state.current.name?$state.current.name.split('.')[1]:location.pathname.split('/')[1];
            $rootScope.bodyClass = [stateName];
        });
    }]);